module.exports = __webpack_public_path__ + "static/media/360e67ac-34da-4280-88df-b9df52dfb3b7.32c7e198.JPG";